import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { eramanCMSApi, post, put } from "~/Services";
import { eramanHost } from "~/Utils";
import { fields } from "../constants";
import { useBrandDocumentDetails } from "./hooks/Brand.hook";

export const FAndBAddEditBrand = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const [records, setRecords] = useState<any[]>([]);
  const { data: editBrand, isLoading, refetch: refetchBrands } = useBrandDocumentDetails(query.get("editId") || "");

  const {
    data: editBrandsById,
    isLoading: isLoadingBrands,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  console.log("editBrandsById", editBrandsById);

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }

    if (query.get("editId")) {
      refetchBrands();
    }
  }, [query.get("editId"), query.get("id")]);

  console.log("Brand data", editBrand, editBrandsById);
  const getRecords = () => {
    let url = `/api/get-all-foodandbeverage-brands`;
    eramanCMSApi
      .get(url)
      .then((res: any) => {
        if (res && res.data) {
          let envelopes = res.data;
          setRecords(envelopes);
        }
      })
      .catch(() => {
        setRecords([]);
      });
  };
  useEffect(() => {
    getRecords();
  }, []);
  const brandFromFields: FormConfig = {
    initialValues: {
      field_common_image: editBrandsById?.payload?.field_common_image
        ? [
            {
              uid: "-1",
              name: "brandImage.png",
              status: "done",
              url: editBrandsById.payload.field_common_image,
            },
          ]
        : editBrand?.field_common_image
          ? [
              {
                uid: "-1",
                name: "brandImage.png",
                status: "done",
                url: editBrand.field_common_image,
              },
            ]
          : "",
      title: editBrandsById?.payload ? decodeHTML(editBrandsById?.payload?.title) : decodeHTML(editBrand?.title),
      field_common_malay_title: editBrandsById?.payload
        ? decodeHTML(editBrandsById?.payload?.field_common_malay_title)
        : decodeHTML(editBrand?.field_common_malay_title || ""),
      field_common_mandarin_title: editBrandsById?.payload
        ? decodeHTML(editBrandsById?.payload?.field_common_mandarin_title)
        : decodeHTML(editBrand?.field_common_mandarin_title || ""),
      published: editBrandsById?.payload ? editBrandsById?.payload?.published : editBrand?.published || false,
    },
    fields: fields.fAndBBrands.map((field: any) => {
      if (field.name === "title") {
        return {
          ...field,
          validation: {
            required: `${field.label || field.name} is required`,
            validate: (value: string, formValues: FieldValues) => {
              if (!value) return true;
              const existingRecord = records.find(
                (record: any) =>
                  decodeHTML(record[field.name]) === decodeHTML(value) &&
                  record.id !== (editBrand?.id || editBrandsById?.payload?.id)
              );
              return !existingRecord || `${field.label || field.name} already exists`;
            },
          },
        };
      }
      if (["field_common_malay_title", "field_common_mandarin_title"].includes(field.name)) {
        return {
          ...field,
          validation: {
            validate: (value: string, formValues: FieldValues) => {
              if (!value) return true; // Skip uniqueness check if empty
              const existingRecord = records.find(
                (record: any) =>
                  decodeHTML(record[field.name]) === decodeHTML(value) &&
                  record.id !== (editBrand?.id || editBrandsById?.payload?.id)
              );
              return !existingRecord || `${field.label || field.name} already exists`;
            },
          },
        };
      }
      return field;
    }),
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    console.log("data-123", data);
    let imageKeys: any = ["field_common_image"];
    for (const key of imageKeys) {
      const field = data[key];

      try {
        if (field?.[0]?.originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "ERAMAN");
          const res: any = await post("management/upload-file", formData);
          if (res) data[key] = res.response.data;
        } else if (field?.[0]?.url) {
          data[key] = field[0].url;
        } else if (Array.isArray(field) && field.length === 0) {
          data[key] = "";
        } else if (!field) {
          data[key] = "";
        }
      } catch (error) {
        console.error(`Error handling image field ${key}:`, error);
      }
    }

    const payload = {
      action: action,
      method: method,
      module: "Product Management",
      subModule: "fAndBBrands",
      type: "DEDICATED",
      application: "ERAMAN",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "ERAMAN",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && { id: editBrand?.id || editBrandsById?.payload?.id }),
        ...data,
        // status: true,
      },
      status: status,
    };

    // Log the complete payload
    console.log("Final Payload:", payload);

    // Commented out API calls for testing
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post(`/management/publish`, payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      // loading={isLoadingBrands}
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} Brand`}
      showBack
    >
      <DynamicForm
        isLoading={isLoading || isLoadingBrands}
        config={brandFromFields}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${query.get("editId") ? `${eramanHost}/api/food-and-beverages-brands-list-page-crud-api/${editBrand?.id || editBrandsById?.payload?.id}` : `${eramanHost}/api/create/food-and-beverages-brands-list-page-crud-api`}`,
            `${query.get("editId") ? "UPDATE" : "CREATE"}`,
            `${query.get("editId") ? "PATCH" : "POST"}`,
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
      />
    </ContentWrapper>
  );
};
